module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specialists"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('crowd-or-rais', {
    attrs: {
      "showStar": false
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("profile.slogan")))]), _vm._v(" "), _c('h2', {
    staticClass: "mb-50"
  }, [_vm._v(_vm._s(_vm.$t("profile.sloganTwo")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "container filters"
  }, [_c('search')], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "all-categories mb-30"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("specialists")))]), _vm._v(" " + _vm._s(_vm.search.profession) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.specialists), function(specialist, index) {
    return _c('specialist-tile', {
      key: specialist.id,
      attrs: {
        "specialist": specialist,
        "size": _vm.tileSize(index)
      }
    })
  }), 1), _vm._v(" "), (!_vm.isLast) ? _c('button', {
    staticClass: "btn btn-lg button-more-crowd",
    attrs: {
      "type": "button",
      "disabled": _vm.show_loader
    },
    on: {
      "click": function($event) {
        return _vm.showMore()
      }
    }
  }, [(!_vm.show_loader) ? _c('span', [_vm._v(_vm._s(_vm.$t("showMore")) + " ")]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.show_loader,
      "color": '#fff',
      "size": '15px'
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115642c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/Index.vue
// module id = 778
// module chunks = 1